var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('layout-complex-sidebar'),_c('layout-complex-topnav'),_c('layout-complex-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }